import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import withReactContent from "sweetalert2-react-content";
import Sw from "sweetalert2";
import Layout from "../../../components/Layout";
import ContainerStyle from "../styles";
import InvoicePix from "./pix";
import useAuth from "../../../hooks/useAuth";
import webSocket from "../../../utils/webSocket";

const Swal = withReactContent(Sw);

function InvoicesPixPage() {
  const navigate = useNavigate();
  const { invoicePix, user } = useAuth();

  useEffect(() => {
    if (!invoicePix?.qrcode) {
      navigate("/faturas");
    }
  }, [invoicePix]);

  useEffect(() => {
    if (user?.id) {
      const channel = `payment-user-${user.id}`;
      webSocket.on(channel, (data) => {
        console.log(data);
        showSwal();
      });
      return () => {
        webSocket.off(channel);
      };
    }
  }, [user]);

  function showSwal() {
    Swal.fire({
      icon: "success",
      title: "Sucesso",
      html: `Pagamento recebido com sucesso!`,
    }).then(() => {
      navigate("/faturas");
    });
  }

  return (
    <Layout>
      <ContainerStyle>
        {invoicePix && <InvoicePix {...invoicePix} />}
      </ContainerStyle>
    </Layout>
  );
}

export default InvoicesPixPage;
